export class Province {

    private _id: number;
    private _name: string;
    private _abbreviation: string;

    constructor() {
        this._id = 0;
        this._name = "";
        this._abbreviation = "";
    }

    get id(): number {
        return this._id;
    }

    set id(value: number) {
        this._id = value;
    }

    get name(): string {
        return this._name;
    }

    set name(value: string) {
        this._name = value;
    }

    get abbreviation(): string {
        return this._abbreviation;
    }

    set abbreviation(value: string) {
        this._abbreviation = value;
    }
}